module.exports = __webpack_public_path__ + "img/31.603ab009.jpg";